import { useState, useEffect } from 'react';
import { get } from '../services/studentService';
import { Student } from '../types';


// TODO: replace dummy data with call to attendanceService.getMonthlyAttendance()
export const useStudent = (admissionNo: string) => {

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string>();
  const [student, setStudent] = useState<Student>(undefined);

  const fetchStudent = async () => {
    try {
      setIsLoading(true)
      const student: Student = await get(admissionNo);
      setStudent(student);
      setIsLoading(false)
    } catch (err) {
      setError("Failed to initialize academic year.");
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchStudent();
  }, []);

  const reload = () => {
    fetchStudent();
  }

  return { student, isLoading, actions: { reload } };
};

